import React from 'react';
import { Modal, Field } from '../../components/ui';
import { RATE_TYPES, SERVICE_STATUSES, OTHER_SERVICE_TYPE, isPerUnit } from './useServices';

// Mobile add/edit service — full screen, one field per row, service picked as chips.
export default function ServiceFormMobile({ vm }) {
  const {
    form, setF, editing, saving, save, setOpen, types, functionOptions, userOptions,
    vendorMode, setVendorMode,
  } = vm;
  const perUnit = isPerUnit(form.RateType);
  const unitWord = form.RateType === 'PerPlate' ? 'Plates confirmed' : form.RateType === 'PerDay' ? 'Days' : form.RateType === 'PerHour' ? 'Hours' : 'Quantity';

  return (
    <Modal
      fullScreen
      title={editing ? `Edit ${editing.ServiceType}` : 'Add Service'}
      onClose={() => setOpen(false)}
      footer={<>
        <button className="btn light" onClick={() => setOpen(false)}>Cancel</button>
        <button className="btn primary" style={{ flex: 1, padding: 12 }} disabled={saving} onClick={save}>
          {saving ? 'Saving...' : 'Save'}
        </button>
      </>}
    >
      <div className="step-label">Which service?</div>
      <div className="chips-row" style={{ marginBottom: 12 }}>
        {types.map(t => (
          <button key={t.ServiceTypeId} type="button"
            className={'chip-toggle' + (String(form.ServiceTypeId) === String(t.ServiceTypeId) ? ' on' : '')}
            onClick={() => setF('ServiceTypeId', String(t.ServiceTypeId))}>{t.ServiceTypeName}</button>
        ))}
        <button type="button" className={'chip-toggle ghost' + (form.ServiceTypeId === OTHER_SERVICE_TYPE ? ' on' : '')}
          onClick={() => setF('ServiceTypeId', OTHER_SERVICE_TYPE)}>Other</button>
      </div>
      {form.ServiceTypeId === OTHER_SERVICE_TYPE && (
        <Field label="New service name" value={form.ServiceType} required onChange={(v) => setF('ServiceType', v)} />
      )}

      <Field label="For function" type="select" value={form.FunctionId} options={functionOptions} onChange={(v) => setF('FunctionId', v)} />
      <Field label="Company name" value={form.CompanyName} onChange={(v) => setF('CompanyName', v)} />
      <Field label="Owner / contact person" value={form.ContactName} onChange={(v) => setF('ContactName', v)} />

      <div className="step-label" style={{ marginTop: 6 }}>Owner login</div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
        <button type="button" className={`btn ${vendorMode === 'new' ? 'primary' : 'light'}`} style={{ padding: 11 }} onClick={() => setVendorMode('new')}>By mobile</button>
        <button type="button" className={`btn ${vendorMode === 'existing' ? 'primary' : 'light'}`} style={{ padding: 11 }} onClick={() => setVendorMode('existing')}>Existing user</button>
      </div>
      {vendorMode === 'existing' ? (
        <Field label="User" type="select" value={form.VendorUserId} options={userOptions} onChange={(v) => setF('VendorUserId', v)} />
      ) : (
        <label className="field">Owner mobile (login, PIN 1234)
          <input type="tel" inputMode="numeric" maxLength={10} value={form.ContactMobile}
            style={{ fontSize: 17, padding: 12, letterSpacing: 1 }} onChange={(e) => setF('ContactMobile', e.target.value)} />
        </label>
      )}

      <div className="step-label" style={{ marginTop: 6 }}>Charges</div>
      <Field label="Rate type" type="select" value={form.RateType} options={RATE_TYPES} onChange={(v) => setF('RateType', v)} />
      <Field label={perUnit ? 'Rate (₹ per unit)' : 'Rate (₹)'} type="number" value={form.Rate} onChange={(v) => setF('Rate', v)} />
      {perUnit && <Field label={unitWord} type="number" value={form.ConfirmedCount} onChange={(v) => setF('ConfirmedCount', v)} />}
      <Field label="Total amount (₹)" type="number" value={form.TotalAmount} onChange={(v) => setF('TotalAmount', v)} />
      {!editing && <Field label="Advance paid now (₹)" type="number" value={form.AdvancePaid} onChange={(v) => setF('AdvancePaid', v)} />}

      <div className="step-label" style={{ marginTop: 6 }}>When</div>
      <Field label="Date" type="date" required value={form.ServiceDate} onChange={(v) => setF('ServiceDate', v)} />
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
        <Field label="Start time" type="time" value={form.StartTime} onChange={(v) => setF('StartTime', v)} />
        <Field label="End time" type="time" value={form.EndTime} onChange={(v) => setF('EndTime', v)} />
      </div>
      <Field label="Status" type="select" value={form.Status} options={SERVICE_STATUSES} onChange={(v) => setF('Status', v)} />
      <Field label="Notes" type="textarea" rows={2} value={form.Notes} onChange={(v) => setF('Notes', v)} />
    </Modal>
  );
}
